// MSN Messenger contact list — skills as buddies, status = mastery.
// Online (green) = fluent (8–9). Away (yellow) = solid working (6–7).
// Busy (red) = comfortable, not in love (4–5). Offline (grey) = mines / rusty.
// { id: "",  name: "",  handle: "",  status: "",   note: "" },
const groups = [
  {
    id: "tech",
    title: "Tech & Data",
    contacts: [
      { id: "python",  name: "Python",          handle: "python3.exe",         status: "on",   note: "Daily driver, most of my work has been in this language. Multiple AI and Data-sciences at home and in school. Most fluent here." },
      { id: "torch",   name: "PyTorch",         handle: "torch.cuda.py",       status: "on",   note: "The AI library I know the most, really like the modularity of it cause I'm the kind of guy that love tweaking parameters to try and optimize. (Grid Search my beloved)" },
      { id: "ia",      name: "ImageAnalysis",   handle: "image-analysis.dll",  status: "on",   note: "Picked up in Ostrava and when I came back to France. Classical CV pipelines, basic CNNs, classifications. I like it but feel like there's way more stuff to do than I know." },
      { id: "GenAI",   name: "Generative AI",   handle: "gen.ai",              status: "on",   note: "Image generation like ControlNet. Text generation, I did two semesters of NLP." },
      { id: "da",      name: "DataAnalysis",    handle: "data-analysis.dll",   status: "on",   note: "Dashboards, pandas / matplotlib / seaborn. Nothing beats a good graph." },
      { id: "git",     name: "Git",             handle: "git-shell.exe",       status: "on",   note: "Rebase over merge. tmux, ssh and my beloved github workflows." },
      { id: "linux",   name: "Linux & CLI",     handle: "bash.sh",             status: "on",   note: "VPS management, cron jobs, and custom shell scripts. Living in the terminal is just faster." },
      { id: "stats",   name: "Statistics",      handle: "stats.r",             status: "on",   note: "I love stats, it's mainly what made me do maths and then artificial intelligence. I think I know a lot but I'm 100% down to learn more in this field." },
      { id: "sql",     name: "SQL",             handle: "sql.dll",             status: "away", note: "I know most of what there is to know and really like it, even though designing databases can be kind of a nightmare." },
      { id: "react",   name: "React",           handle: "react.dll",           status: "away", note: "This entire site is the proof of concept. Hooks, contexts, state management at portfolio scale." },
      { id: "java",    name: "Java",            handle: "java.dll",            status: "away", note: "Vilnius semester legacy. JPA + Spring. I can do it; I don't seek it out." },
      { id: "pg",      name: "PostgreSQL",      handle: "postgres.dll",        status: "busy", note: "Indexing, partitioning, basic perf debugging. Used at Baker Tilly on the data-pipeline logging system." },
      { id: "greenai", name: "GreenAI",         handle: "green-ai.cfg",        status: "busy", note: "We had a lot of sensibilisation about green tech and green IA in school. Might be due to my double background but I like it." },
      { id: "greenai", name: "GreenAI",         handle: "green-ai.cfg",        status: "busy", note: "We had a lot of sensibilisation about green tech and green IA in school. Might be due to my double background but I like it." },
      { id: "ccpp",    name: "C / C++",         handle: "c-cpp.dll",           status: "busy", note: "Comfortable, not in love. Pointers and headers don't scare me anymore." },
      { id: "net",     name: "Networking",      handle: "nginx.conf",          status: "busy", note: "Nginx, Tailscale, and reverse proxies. Making sure my services are actually reachable and secure. I understand and hate it equally, that's why it is this low." },
      { id: "asm",     name: "Assembly",        handle: "assembly.sys",        status: "off",  note: "Yes, really. One semester at VŠB-TU Ostrava, and I had fun. Made me write better C afterwards. But still something really hard." },
    ]
  },
  {
    id: "soft",
    title: "Soft skills",
    contacts: [
      { id: "teach",  name: "Teaching",       handle: "teaching.svc",       status: "on",   note: "Three years as a volunteer IT teacher to elders. I default to explaining instead of fixing, usually the cheaper option long-term." },
      { id: "adapt",  name: "Adaptability",   handle: "adaptability.svc",   status: "on",   note: "Four Erasmus exchanges in four different countries. New place, new people, new language, I land on my feet quickly." },
      { id: "comm",   name: "Communication",  handle: "communication.svc",  status: "on",   note: "Clear over clever. I'd rather over-explain than leave a teammate guessing. Please cut short my explanation if something is unclear." },
      { id: "honest", name: "Honesty",        handle: "honesty.svc",        status: "on",   note: "I'll tell you when something is broken, including when I'm the one who broke it. Bugs at minute 10 are a quarter as expensive as bugs at minute 100." },
      { id: "curi",   name: "Curiosity",      handle: "curiosity.svc",      status: "on",   note: "Reads papers, builds tiny ugly weekend prototypes. Don't like waiting for approval to try stuff." },
      { id: "press",  name: "Pressure-Team",  handle: "pressure-team.svc",  status: "away", note: "McDonald's rush hour was a crash course. I stay calm and useful when things are on fire." }
    ]
  },
  {
    id: "lng",
    title: "Languages",
    contacts: [
      { id: "fr",  name: "French",  handle: "french.lng",  status: "on",   note: "Really good even for a native was ~800/1000 on Project Voltaire (french TOEFL)" },
      { id: "en",  name: "English", handle: "english.lng", status: "on",   note: "TOEIC 990/990. All my engineering studies in EN, four Erasmus exchanges. Most people I talk to aside from my parents are foreigners." },
      { id: "nl",  name: "Dutch",   handle: "dutch.lng",   status: "busy", note: "I love this language but this is so difficult, please someone help me." },
      { id: "es",  name: "Spanish", handle: "spanish.lng", status: "off",  note: "I spent all my life speaking fluently in English so that I never found the will to learn Spanish. Now when I try I have a literal decade of delay." }
    ]
  }
];

const allContacts = groups.flatMap(g => g.contacts);
const cid = id => `msn-c-${id}`;

const statusLabel = {
  on:   "Online",
  away: "Away",
  busy: "Busy",
  off:  "Offline"
};

const statusDot = (s, extra = "") =>
  `<span class="msn-dot msn-dot-${s} ${extra}" aria-hidden="true"></span>`;

// Stable pseudo-time per contact, just for the bubble timestamp
const fakeTime = id => {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  const hh = (8 + (h % 11)).toString().padStart(2, "0"); // 08..18
  const mm = (h % 60).toString().padStart(2, "0");
  return `${hh}:${mm}`;
};

const radios = allContacts
  .map(c => `<input type="radio" name="msn-sel" id="${cid(c.id)}" class="msn-r" />`)
  .join("");

const renderContact = c => `
  <label for="${cid(c.id)}" class="msn-row msn-row-${c.status}" title="${c.name} — ${statusLabel[c.status]}">
    ${statusDot(c.status)}
    <span class="msn-name">${c.name}</span>
    <span class="msn-handle">&lt;${c.handle}&gt;</span>
  </label>
`;

const renderGroup = g => {
  const onCount = g.contacts.filter(c => c.status !== "off").length;
  return `
    <div class="msn-group">
      <div class="msn-group-head">▾ ${g.title} <span class="msn-group-count">(${onCount}/${g.contacts.length})</span></div>
      <div class="msn-group-body">
        ${g.contacts.map(renderContact).join("")}
      </div>
    </div>
  `;
};

const headFor = c => `
  <div class="msn-h msn-h-${c.id}">
    ${statusDot(c.status)}
    <span class="msn-h-name">${c.name}</span>
    <span class="msn-h-status">— ${statusLabel[c.status]}</span>
    <span class="msn-h-handle">&lt;${c.handle}&gt;</span>
  </div>
`;

const detailFor = c => `
  <div class="msn-d msn-d-${c.id}">
    <div class="msn-bubble msn-bubble-${c.status}">
      <div class="msn-bubble-meta">
        <b>${c.name}</b> says <span class="msn-bubble-time">(${fakeTime(c.id)} PM)</span>:
      </div>
      <div class="msn-bubble-body">"${c.note}"</div>
    </div>
    <div class="msn-d-tail">
      ${statusDot(c.status)} ${statusLabel[c.status]} · <code>&lt;${c.handle}&gt;</code>
    </div>
  </div>
`;

const allHeads = allContacts.map(headFor).join("");
const allDetails = allContacts.map(detailFor).join("");

const showBodySelectors = allContacts
  .map(c => `.msn-root:has(#${cid(c.id)}:checked) .msn-d-${c.id}`)
  .join(",\n");
const showHeadSelectors = allContacts
  .map(c => `.msn-root:has(#${cid(c.id)}:checked) .msn-h-${c.id}`)
  .join(",\n");
const hideDefaultBody = allContacts
  .map(c => `.msn-root:has(#${cid(c.id)}:checked) .msn-d-default`)
  .join(",\n");
const hideDefaultHead = allContacts
  .map(c => `.msn-root:has(#${cid(c.id)}:checked) .msn-h-default`)
  .join(",\n");
const highlightSelectors = allContacts
  .map(c => `.msn-root:has(#${cid(c.id)}:checked) label[for="${cid(c.id)}"]`)
  .join(",\n");

const onlineTotal = allContacts.filter(c => c.status === "on").length;

const html = `
<style>
*:has(> .msn-root) {
  background: #ece9d8 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
.msn-root {
  font-family: "MS Sans Serif", Tahoma, sans-serif;
  font-size: 12px;
  color: #000;
  background: #ece9d8;
  flex: 1 1 auto;
  min-height: 100%;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.msn-r { position: absolute; opacity: 0; pointer-events: none; }

/* ---- Banner ---------------------------------------------------- */
.msn-banner {
  background:
    linear-gradient(180deg, #6cb1f6 0%, #4181d6 50%, #2a5fa8 100%);
  color: #fff;
  padding: 6px 10px;
  border: 2px solid;
  border-color: #fff #404040 #404040 #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.msn-banner::after {
  content: "";
  position: absolute;
  top: 2px; left: 2px; right: 2px;
  height: 6px;
  background: linear-gradient(180deg, rgba(255,255,255,0.45), rgba(255,255,255,0));
  pointer-events: none;
}
.msn-avatar {
  width: 36px; height: 36px;
  background: linear-gradient(180deg, #ffe97a 0%, #f0a500 100%);
  border: 2px solid;
  border-color: #fff #808080 #808080 #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #4a2a00;
  font-weight: bold;
  text-shadow: 0 1px 0 rgba(255,255,255,0.4);
  flex-shrink: 0;
}
.msn-me { display: flex; flex-direction: column; line-height: 1.25; flex: 1; min-width: 0; }
.msn-me-name { font-weight: bold; font-size: 13px; display: flex; align-items: center; gap: 6px; }
.msn-me-name .msn-dot { box-shadow: 0 0 0 1px rgba(0,0,0,0.3); }
.msn-me-status { font-size: 11px; opacity: 0.95; font-style: italic; }
.msn-banner-right {
  font-size: 11px;
  opacity: 0.95;
  text-align: right;
  white-space: nowrap;
  line-height: 1.3;
}
.msn-banner-right b { font-size: 13px; }
.msn-banner-email {
  display: inline-block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.2px;
}

/* ---- Body: list + chat ---------------------------------------- */
.msn-body {
  display: flex;
  gap: 6px;
  flex: 1 1 auto;
  min-height: 0;
}

/* Contact list */
.msn-list {
  background: #fff;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
  padding: 4px 0;
  width: 280px;
  min-width: 240px;
  overflow: auto;
}
.msn-group { margin-bottom: 4px; }
.msn-group-head {
  background: linear-gradient(180deg, #fbfbf7 0%, #ddd9c6 100%);
  color: #003399;
  font-weight: bold;
  font-size: 11px;
  padding: 2px 8px;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #aaa;
  user-select: none;
  letter-spacing: 0.2px;
}
.msn-group-count { color: #666; font-weight: normal; }
.msn-group-body { padding: 2px 0 4px 0; }

.msn-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px 2px 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.08s;
}
.msn-row:hover { background: #e6f0fb; }
.msn-name { font-size: 12px; }
.msn-handle { font-size: 10px; color: #888; font-style: italic; }

.msn-row-off .msn-name { color: #888; }
.msn-row-off .msn-handle { color: #aaa; }
.msn-row-busy .msn-name { color: #a00; }

/* Status dots */
.msn-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.4);
  background: #888;
  display: inline-block;
  position: relative;
}
.msn-dot-on   { background: radial-gradient(circle at 30% 30%, #b6f0a8, #2da028); }
.msn-dot-away { background: radial-gradient(circle at 30% 30%, #ffe89a, #d49b16); }
.msn-dot-busy { background: radial-gradient(circle at 30% 30%, #ffa0a0, #c81818); }
.msn-dot-off  { background: radial-gradient(circle at 30% 30%, #d0d0d0, #707070); }

/* Subtle pulse on online dots */
.msn-dot-on::after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 1px solid rgba(45, 160, 40, 0.6);
  animation: msn-pulse 2.4s ease-out infinite;
  pointer-events: none;
}
@keyframes msn-pulse {
  0%   { transform: scale(0.7); opacity: 0.9; }
  80%  { transform: scale(1.6); opacity: 0; }
  100% { transform: scale(1.6); opacity: 0; }
}

/* Selected highlight in list */
${highlightSelectors} {
  background: linear-gradient(180deg, #4a90e8 0%, #1d61c0 100%);
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.3);
}
${highlightSelectors} .msn-name,
${highlightSelectors} .msn-handle { color: #fff !important; }
${highlightSelectors} .msn-dot { box-shadow: 0 0 0 1px #fff; }

/* ---- Chat panel ----------------------------------------------- */
.msn-chat {
  flex: 1 1 auto;
  background: #fff;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.msn-chat-head {
  background: linear-gradient(180deg, #6cb1f6 0%, #2a5fa8 100%);
  color: #fff;
  font-weight: bold;
  padding: 4px 8px;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 2px solid #fff;
  white-space: nowrap;
  overflow: hidden;
}
.msn-chat-head .msn-h-name { font-size: 12px; }
.msn-chat-head .msn-h-status { font-weight: normal; opacity: 0.85; }
.msn-chat-head .msn-h-handle {
  font-weight: normal;
  font-style: italic;
  opacity: 0.7;
  font-size: 10px;
  margin-left: auto;
}
.msn-chat-head .msn-dot { box-shadow: 0 0 0 1px rgba(255,255,255,0.6); }

.msn-h { display: none; align-items: center; gap: 8px; flex: 1; min-width: 0; }
.msn-h-default { display: flex; }
${showHeadSelectors} { display: flex; }
${hideDefaultHead} { display: none; }

.msn-nudge-btn {
  font-size: 10px;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #fff #808080 #808080 #fff;
  padding: 1px 8px;
  cursor: pointer;
  color: #000;
  font-family: inherit;
  flex-shrink: 0;
}
.msn-nudge-btn:active { border-color: #808080 #fff #fff #808080; }

.msn-chat-body {
  flex: 1 1 auto;
  padding: 12px 14px;
  overflow: auto;
  font-size: 12.5px;
  line-height: 1.55;
  color: #000;
  background:
    linear-gradient(180deg, #fbfbff 0%, #f4f6fb 100%);
}

.msn-d { display: none; }
.msn-d-default { display: block; color: #444; }
${showBodySelectors} { display: block; }
${hideDefaultBody} { display: none; }

/* Welcome cards */
.msn-welcome p { margin: 0 0 6px 0; }
.msn-legend-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  margin: 8px 0 6px 0;
}
.msn-legend-card {
  background: #fff;
  border: 1px solid #b8c4d8;
  padding: 6px 8px;
  font-size: 11px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 2px;
}
.msn-legend-card b { color: #003399; }
.msn-legend-card .msn-dot { width: 12px; height: 12px; }
.msn-tip {
  font-size: 11px;
  color: #555;
  border-top: 1px dashed #c0c0c0;
  padding-top: 6px;
  margin-top: 6px;
}

/* Chat bubble */
.msn-bubble {
  background: #fff;
  border: 1px solid #b8c4d8;
  border-left: 3px solid #2a5fa8;
  padding: 6px 10px;
  border-radius: 3px;
  box-shadow: 1px 1px 0 rgba(0,0,0,0.04);
  margin-bottom: 8px;
  position: relative;
}
.msn-bubble-on   { border-left-color: #2da028; }
.msn-bubble-away { border-left-color: #d49b16; }
.msn-bubble-busy { border-left-color: #c81818; }
.msn-bubble-off  { border-left-color: #707070; background: #f4f4f4; }
.msn-bubble-meta {
  font-size: 10.5px;
  color: #555;
  margin-bottom: 3px;
}
.msn-bubble-meta b { color: #003399; }
.msn-bubble-time { color: #999; font-size: 10px; }
.msn-bubble-body {
  font-style: italic;
  color: #111;
}
.msn-d-tail {
  font-size: 10.5px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}
.msn-d-tail code {
  font-family: "Courier New", monospace;
  background: #f0f0f0;
  padding: 0 4px;
  border: 1px solid #d8d8d8;
}

/* Decorative chat input */
.msn-chat-foot {
  border-top: 2px solid #c0c0c0;
  padding: 4px 6px;
  background: #f0eee0;
}
.msn-emojis {
  font-size: 12px;
  letter-spacing: 6px;
  color: #b07000;
  padding-bottom: 3px;
  user-select: none;
}
.msn-input {
  background: #fff;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
  padding: 3px 6px;
  font-size: 11px;
  color: #aaa;
  font-style: italic;
  cursor: not-allowed;
}

/* ---- Footer status bar --------------------------------------- */
.msn-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  color: #444;
  padding: 2px 6px;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
  background: #ece9d8;
  gap: 8px;
}
.msn-foot-net {
  display: flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 620px) {
  .msn-list { width: 200px; min-width: 160px; }
  .msn-handle { display: none; }
  .msn-legend-cards { grid-template-columns: 1fr; }
  .msn-chat-head .msn-h-handle { display: none; }
}
</style>

<div class="msn-root">
  <input type="radio" name="msn-sel" id="msn-default" class="msn-r" checked />
  ${radios}

  <div class="msn-banner">
    <div class="msn-avatar">N</div>
    <div class="msn-me">
      <span class="msn-me-name">${statusDot("on")} Noé Guengant</span>
      <span class="msn-me-status">"shipping things, occasionally on time"</span>
    </div>
    <div class="msn-banner-right">
      <b>${onlineTotal}</b> online · ${allContacts.length} total<br/>
      <span class="msn-banner-email">guengant.noe@gmail.com</span>
    </div>
  </div>

  <div class="msn-body">
    <div class="msn-list">
      ${groups.map(renderGroup).join("")}
    </div>

    <div class="msn-chat">
      <div class="msn-chat-head">
        <div class="msn-h msn-h-default">
          ${statusDot("on")}
          <span class="msn-h-name">Conversation</span>
          <span class="msn-h-status">- pick a buddy</span>
        </div>
        ${allHeads}
        <label for="msn-default" class="msn-nudge-btn" title="Reset selection">↺ Nudge</label>
      </div>

      <div class="msn-chat-body">
        <div class="msn-d msn-d-default msn-welcome">
          <p><b>Hey 👋</b> - the list on the left is my skill stack as MSN buddies. Status = mastery:</p>
          <div class="msn-legend-cards">
            <div class="msn-legend-card">${statusDot("on")}<span><b>Online</b><br/><small>fluent · daily-driver</small></span></div>
            <div class="msn-legend-card">${statusDot("away")}<span><b>Away</b><br/><small>solid · used regularly</small></span></div>
            <div class="msn-legend-card">${statusDot("busy")}<span><b>Busy</b><br/><small>comfortable · not in love</small></span></div>
            <div class="msn-legend-card">${statusDot("off")}<span><b>Offline</b><br/><small>rusty · in progress</small></span></div>
          </div>
          <div class="msn-tip">Click any contact to open the conversation. ↺ Nudge clears the selection.</div>
        </div>
        ${allDetails}
      </div>

      <div class="msn-chat-foot">
        <div class="msn-emojis" aria-hidden="true">:) ;) :( :P :D &lt;3 (Y) (N)</div>
        <div class="msn-input">Type a message and press Enter to send…</div>
      </div>
    </div>
  </div>

  <div class="msn-foot">
    <div class="msn-foot-net">${statusDot("on")} Connected - guengant.noe@gmail.com</div>
    <div>MSN Messenger 4.7</div>
  </div>
</div>
`;

export default html;
